import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button } from 'semantic-ui-react'

import ThemeButton from "./ThemeButton";

import { gameActions } from "../store/game-slice";

function ThemeChooser(props) {
  const dispatch = useDispatch();

  const themes = useSelector((state) => state.game.themes);

  const [currentTheme, setCurrentTheme] = useState('');
  const [themeRequiredMessage, setThemeRequiredMessage] = useState('');

  function beginGame(theme) {
    dispatch(gameActions.setTheme(theme));
    dispatch(gameActions.setGameRestarted(true));

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }

  function btnThemeClickHandler(theme) {
    if(props.startGame) {
      beginGame(theme);
    } else {
      setCurrentTheme(() => theme);
    }
  }

  function btnLetsPlayClickHandler(e) {
    setThemeRequiredMessage(() => '');
    if(currentTheme) {
      beginGame(currentTheme);
    } else {
        setThemeRequiredMessage(() => 'Please select a theme.');
    }

    if(props.onPlayClick) {
      props.onPlayClick();
    }
  }

  return (
    <section className="theme-chooser">
      <header className="logo-header">
      <img src="images/ezpass.svg" className="ez-logo"></img>
      <img src="images/bingo.svg" className="bingo-logo"></img>
      <div className="chooser-container">
        <p>Choose a Theme</p>
        <ul className="theme-menu">
        {Object.keys(themes).map(function(key) {
              return <ThemeButton
              key={key}
              id={key}
              title={themes[key].title}
              image={themes[key].thumb}
              selected={key===currentTheme}
              onClickHandler={btnThemeClickHandler}
              />
          })}
        </ul>
      </div>
      {themeRequiredMessage && <p className="error">{themeRequiredMessage}</p>}
      {!props.startGame && <Button onClick={btnLetsPlayClickHandler}>{props.buttonLabel}</Button>}
      </header>
      
      
    </section>
  );
}

export default ThemeChooser;
